import { List, Map as ImmutableMap } from 'immutable';
import { APP_OPTIONS_SET, THEME_FIELD_BLURRED, THEME_FIELD_FOCUSED, RELOAD_IFRAME_PREVIEW, IFRAME_PREVIEW_LOADED, IFRAME_PREVIEW_LOAD_FAILED, SET_IFRAME_TIMEOUT_ERROR, CLEAR_IFRAME_TIMEOUT_ERROR, SET_IFRAME_PREVIEW_LOADING, PREVIEW_IFRAME_READY, UPDATE_BREAKPOINT, SET_IS_PRESET_PANEL_OPEN, SET_PORTALS_HMR, PORTALS_THEME_UPDATE_RECEIVED } from '../actions/ActionTypes';
import { DebugOptions } from '../constants';
const DEFAULT_STATE = ImmutableMap({
  debugMode: false,
  globalStylesTestMode: false,
  focusedFieldKeys: List([]),
  iframeLoadTimedOut: false,
  initialIframeLoadExecuted: false,
  isPresetPanelOpen: false,
  isPortalsHmrReady: false,
  portalsLastUpdateReceived: null,
  previewDomain: null,
  previewIframeLoaded: false,
  previewIframeLoading: false,
  previewIframeReady: false,
  previewCacheBust: Date.now(),
  selectedBreakpoint: undefined,
  testMode: false,
  [DebugOptions.HIGHLIGHT_FIELD_SELECTORS]: false,
  [DebugOptions.PREVIEW_DEVICES]: false,
  [DebugOptions.JAVASCRIPT_INTEGRATION]: false
});
const appReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case APP_OPTIONS_SET:
      return state.merge(action.payload);
    case THEME_FIELD_FOCUSED:
      {
        const {
          fieldKey
        } = action.payload;
        const fieldKeys = state.get('focusedFieldKeys');
        if (fieldKeys.includes(fieldKey)) return state;
        const newFieldKeys = fieldKeys.concat(fieldKey);
        return state.merge({
          focusedFieldKeys: newFieldKeys
        });
      }
    case THEME_FIELD_BLURRED:
      {
        const {
          fieldKey
        } = action.payload;
        const fieldKeys = state.get('focusedFieldKeys');
        const fieldKeyIndex = fieldKeys.indexOf(fieldKey);
        if (fieldKeyIndex < 0) return state;
        return state.deleteIn(['focusedFieldKeys', fieldKeyIndex]);
      }
    case RELOAD_IFRAME_PREVIEW:
      return state.set('previewCacheBust', Date.now());
    case SET_IFRAME_PREVIEW_LOADING:
      return state.merge({
        iframeLoadTimedOut: false,
        previewIframeLoaded: false
      });
    case IFRAME_PREVIEW_LOADED:
      return state.merge({
        previewIframeLoaded: true,
        initialIframeLoadExecuted: true
      });
    case IFRAME_PREVIEW_LOAD_FAILED:
      return state.set('initialIframeLoadExecuted', true);
    case SET_IFRAME_TIMEOUT_ERROR:
      return state.set('iframeLoadTimedOut', true);
    case CLEAR_IFRAME_TIMEOUT_ERROR:
      return state.set('iframeLoadTimedOut', false);
    case PREVIEW_IFRAME_READY:
      return state.set('previewIframeReady', true);
    case UPDATE_BREAKPOINT:
      {
        const {
          breakpointName
        } = action.payload;
        return state.set('selectedBreakpoint', breakpointName);
      }
    case SET_IS_PRESET_PANEL_OPEN:
      {
        var _action$payload;
        return state.set('isPresetPanelOpen', Boolean((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.isPresetPanelOpen));
      }
    case SET_PORTALS_HMR:
      {
        const newValue = Boolean(action.payload);
        return state.set('isPortalsHmrReady', newValue);
      }
    case PORTALS_THEME_UPDATE_RECEIVED:
      {
        return state.set('portalsLastUpdateReceived', Date.now());
      }
    default:
      return state;
  }
};
export default appReducer;